export type AppEnv = "development" | "production" | "test";

export function getAppEnv(): AppEnv {
  const appEnv = process.env.APP_ENV?.toLowerCase();
  if (
    appEnv === "development" ||
    appEnv === "production" ||
    appEnv === "test"
  ) {
    return appEnv;
  }

  const nodeEnv = process.env.NODE_ENV?.toLowerCase();
  if (
    nodeEnv === "development" ||
    nodeEnv === "production" ||
    nodeEnv === "test"
  ) {
    return nodeEnv;
  }

  return "development";
}

export const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL ?? "";

export const MAIN_API_BASE_URL =
  process.env.NEXT_PUBLIC_GOLANG_API_BASE_URL ?? "";

export const RUST_API_BASE_URL =
  process.env.NEXT_PUBLIC_RUST_API_BASE_URL ?? "";

export const RUST_PDF_API_BASE_URL =
  process.env.NEXT_PUBLIC_RUST_PDF_API_BASE_URL ?? "";

export const NEXT_PUBLIC_ADMIN_APP_URL =
  process.env.NEXT_PUBLIC_ADMIN_APP_URL ?? "";

if (!API_BASE_URL || !MAIN_API_BASE_URL) {
  console.error("Missing API base URLs in environment variables");
}
